const filterStatusesParser = (array) => {
  if (array)
    return [
      ...new Set(
        array
          ?.map((el) => el?.statusInfo?.status?.toLowerCase()?.split(','))
          ?.flat()
      ),
    ];
};

export default filterStatusesParser;
